var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spray"},[_c('Page',{attrs:{"search-bar":_vm.searchBar,"table":_vm.table,"pagination":_vm.pagination,"hiddenOperate":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }